import React from 'react';
import CountUp from 'react-countup';
import './achievements.css';

const Achievements = () => {
  return (
    <section className="achievement-section py-5">
      <div className="container text-center">
        <h2 className="section-title mb-4">OUR ACHIEVEMENTS</h2>
        <p className="section-subtitle mb-5">
          Trusted by thousands nationwide, delivering fast, secure loans with a proven track record of reliability and customer satisfaction.
        </p>

        <div className="row g-4 justify-content-center">
          {[
            {
              icon: 'fas fa-rupee-sign',
              value: 100,
              suffix: ' Cr+',
              label: 'Loans Disbursed Nationwide',
              prefix: '₹',
              duration: 2
            },
            {
              icon: 'fas fa-users',
              value: 50000,
              suffix: '+',
              label: 'Borrowers Across India ',
              separator: ',',
              duration: 2
            },
            {
              icon: 'fas fa-bolt',
              value: 5,
              suffix: ' Min',
              label: 'Quick Approvals, Swift Disbursal',
              duration: 2
            },
            {
              icon: 'fas fa-shield-alt',
              value: 100,
              suffix: '%',
              label: 'Data Protected, Always.',
              duration: 2
            }
          ].map((item, index) => (
            <div className="col-6 col-sm-4 col-lg-3 d-flex" key={index}>
              <div className="achievement-box w-100">
                <div className="icon mb-3">
                  <i className={item.icon}></i>
                </div>
                <h3 className="count">
                  {item.prefix || ''}
                  <CountUp
                    end={item.value}
                    duration={item.duration}
                    separator={item.separator || ''}
                  />
                  {item.suffix}
                </h3>
                <p className="label">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;
